import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "rounded" }
const _hoisted_3 = { class: "mx-2" }
const _hoisted_4 = { class: "form-group mb-4" }
const _hoisted_5 = { class: "w-100 d-block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "default" }, [
  /*#__PURE__*/_createTextVNode("Evènement médical associé"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1)
const _hoisted_7 = {
  slot: "option",
  "slot-scope": "{ props }"
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "" }, [
  /*#__PURE__*/_createTextVNode("Niveau d'urgence de la prescription"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1)
const _hoisted_10 = { class: "border rounded p-2" }
const _hoisted_11 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "" }, [
  /*#__PURE__*/_createTextVNode("Option de financement"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1)
const _hoisted_14 = { class: "border rounded p-2" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, [
  /*#__PURE__*/_createTextVNode("Raison de la prescription"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "*")
], -1)
const _hoisted_17 = { class: "border rounded p-2" }
const _hoisted_18 = { class: "d-flex flex-wrap align-items-center gap-2" }

import { ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import VueMultiselect from "vue-multiselect";
import moment from "moment";
import NiveauUrgenceService from "@/_services/NiveauUrgenceService";
import OptionFinancementService from "@/_services/OptionFinancementService";
import TimelineService from "@/_services/TimelineService";
import { toRefs, watch } from "vue";
import PrescriptionService from "@/_services/PrescriptionService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdministrativeData',
  props: {
  state: {
    type: Object,
    required: true,
    default: false,
  },
  v$: {
    type: Object,
    required: true,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
// const emit = defineEmits(['update:state.evenement_medical'])
// function updateValue(option:any) {
//   emit('update:state.evenement_medical', option.description)
// }
const niveauUrgence = ref([]);
const NiveauDurgence = async () => {
  await NiveauUrgenceService.getNiveau_urgences()
    .then((response) => {
      if (niveauUrgence.value) {
        niveauUrgence.value = response.data.data;
      } else {
        return niveauUrgence.value;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// nameLigne ({ date, motif }) {
//     return `${motif} — ${date}`
// },

const optionfinancement = ref([]);
const Optionfinancement = async () => {
  await OptionFinancementService.getOptionFinancement()
    .then((response) => {
      optionfinancement.value = response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

// const onSelect = (option:any) =>{
//     props.state.evenement_medical = option.description
//     }

const timelineData = ref([]);
const timelineDate = ref([]);
const patient_id = store.state.patient.select.user?.id;

const fetchTimelinePatient = async () => {
  await TimelineService.getTimeline(patient_id, "patient")
    .then((response) => {
      timelineData.value = response.data.map((data: any) => ({
        id: data.id,
        description: data.description,
      }));
    })
    .catch((error) => {
      console.log(error);
    });
};

// const nameLigne = () => {
//     let date = moment(timelineDate.value).format("YYYY-MM-DD");
//     return timelineData.value + " — " + date;
// }

const raisonPrescription = ref([]);

const fetchRaisonPrescription = async () => {
  await PrescriptionService.getRaisonPrescriptions()
    .then((response) => {
      raisonPrescription.value = response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

onMounted(() => {
  NiveauDurgence();
  Optionfinancement();
  fetchTimelinePatient();
  fetchRaisonPrescription();
  // props.state.state.evenement_medical = timelineData.value.find(option => option.id === props.state.state.evenement_medical);
});

// https://www.back.medsurlink.com/api/timelines/nouveau-1675184537-34046734/patient

return (_ctx: any,_cache: any) => {
  const _component_b_form_radio = _resolveComponent("b-form-radio")!
  const _component_b_form_checkbox_group = _resolveComponent("b-form-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(VueMultiselect), {
              modelValue: __props.state.evenement_medical.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.state.evenement_medical.id) = $event)),
              options: timelineData.value,
              "preserve-search": true,
              placeholder: "Rechercher un Patient",
              label: "description",
              "track-by": "id",
              "preselect-first": false,
              onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:state.evenement_medical', $event.target)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("template", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString(props.option.description), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(niveauUrgence.value, (niveau_urgence, index) => {
                return (_openBlock(), _createBlock(_component_b_form_radio, {
                  modelValue: __props.state.niveau_urgence.id,
                  "onUpdate:modelValue": ($event: any) => ((__props.state.niveau_urgence.id) = $event),
                  key: index,
                  name: "niveau-urgence",
                  value: niveau_urgence
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Urgence " + _toDisplayString(niveau_urgence.valeur), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
              }), 128))
            ]),
            (__props.state.niveau_urgence)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["mt-2 p-2 rounded", [
                __props.state.niveau_urgence.id.valeur == 1
                  ? 'urgence-1'
                  : __props.state.niveau_urgence.id.valeur == 3
                  ? 'urgence-3'
                  : __props.state.niveau_urgence.id.valeur == 4
                  ? 'urgence-4'
                  : __props.state.niveau_urgence.id.valeur == 5
                  ? 'urgence-5'
                  : 'urgence-1',
              ]])
                }, [
                  _createElementVNode("small", null, _toDisplayString(__props.state.niveau_urgence?.id.description), 1)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_b_form_checkbox_group, {
              modelValue: __props.state.option_financement.id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.state.option_financement.id) = $event)),
              options: optionfinancement.value,
              class: "mb-3 d-flex flex-wrap",
              "value-field": "id",
              "text-field": "libelle",
              "disabled-field": "notEnabled"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(raisonPrescription.value, (raison_prescription, index) => {
                return (_openBlock(), _createBlock(_component_b_form_radio, {
                  modelValue: __props.state.raison_prescription.id,
                  "onUpdate:modelValue": ($event: any) => ((__props.state.raison_prescription.id) = $event),
                  key: index,
                  name: "raison-prescription",
                  value: raison_prescription,
                  "disabled-field": "notEnabled"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(raison_prescription?.libelle), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "value"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})